import { OG_META_DATA_KEY } from '@opengov/reporting-types';

export const DEFAULT_CHART_WIDTH = 1200;
export const DEFAULT_CHART_HEIGHT = 360;

export const DEFAULT_Y_AXIS_LABEL_SPACING = 8;
export const DEFAULT_CHART_MIN_BANDWIDTH = 30;

export const nonGraphableKeys = ['name', 'id', OG_META_DATA_KEY];
export const OG_TARGET_CATEGORY = 'OG_TARGET_CATEGORY_OG';
